const navButton = document.querySelector(".nav-button");
const mobileNav = document.querySelector(".mobile-navigation");
const navLinks = document.querySelectorAll(".mobile-nav-link");

if (navButton && mobileNav) {
    navButton.addEventListener("click", () => {
        navButton.classList.toggle("open");
        mobileNav.classList.toggle("open");
    });

    navLinks.forEach((link) => {
        link.addEventListener("click", () => {
            navButton.classList.remove("open");
            mobileNav.classList.remove("open");
        });
    });
}
